import i18n from 'i18next'
import antdKoKR from 'antd/es/locale/ko_KR'
import antdEnUS from 'antd/es/locale/en_US'
import antdZhCn from 'antd/es/locale/zh_CN'
import antdFrFR from 'antd/es/locale/fr_FR'
import antdJaJP from 'antd/es/locale/ja_JP'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import fetch from 'auth/FetchInterceptor'
import 'dayjs/locale/ko'
import UserHelper from '../utils/user'

let lang = 'en'
if (navigator.language != null) lang = navigator.language // 언어 값이 있을 경우 lang에 저장

lang = lang.toLowerCase().substring(0.2) // 저장된 언어 값을 0부터 2까지 자르고 소문자로 변환하여 lang에 저장

export const resources = {
  ko: {
    antd: antdKoKR,
  },
  en: {
    antd: antdEnUS,
  },
  zh: {
    antd: antdZhCn,
  },
  fr: {
    antd: antdFrFR,
  },
  ja: {
    antd: antdJaJP,
  },
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: UserHelper.userInfo()?.langCode.toLowerCase() || lang || 'en', // default language
    fallbackLng: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: '/locale/{{lng}}',
      request: async (options, url, payload, callback) => {
        try {
          const response = await fetch({
            url: url,
            method: 'post',
            headers: { 'X-Http-Method-Override': 'GET' },
          })

          callback(null, { data: response, status: 200 })
        } catch (error) {
          console.error('Failed to fetch translation:', error)
          callback(error, false)
        }
      },
    },
  })

export default i18n
